import { Button } from '@/components/ui/button';
import { APPLY_DEFAULTS_LABEL, CANCEL_LABEL } from '@/lib/designations/organisationDefaults';

interface DefaultColumnEditorProps {
  onCancel: () => void;
  onApply: () => void;
  applying?: boolean;
}

const DefaultColumnEditor = ({ onCancel, onApply, applying = false }: DefaultColumnEditorProps) => {
  return (
    <div
      data-testid="default-column-banner"
      className="mb-3 flex items-center justify-between gap-3 rounded-lg border border-[#e9eaee] bg-[#f7f8fa] px-4 py-3"
      role="region"
      aria-label="Default column editor"
    >
      <p className="text-sm text-[#0f1222]">Choose the Sold As and Bought As columns, then apply.</p>
      <div className="flex gap-2">
        <Button type="button" variant="outline" onClick={onCancel} data-testid="default-column-cancel">
          {CANCEL_LABEL}
        </Button>
        <Button type="button" onClick={onApply} disabled={applying} data-testid="default-column-apply">
          {APPLY_DEFAULTS_LABEL}
        </Button>
      </div>
    </div>
  );
};

export default DefaultColumnEditor;
